import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Filter, Download, Eye } from "react-feather";
import { Dropdown, Spinner } from "react-bootstrap";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";

const SellerListCost = () => {
  const [sellers, setSellers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // Search handler
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearch(term);
    setFilteredData(
      sellers.filter((seller) =>
        `${seller.first_name} ${seller.last_name}`.toLowerCase().includes(term)
      )
    );
    setCurrentPage(1);
  };

  // Excel Download
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Seller Report");
    XLSX.writeFile(wb, "seller_report.xlsx");
  };

  // Fetch sellers from getProductStatsBySeller API
  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const response = await axios.get(`${baseurl}getProductStatsBySeller`);
        if (response.data.message === "Fetched product stats by seller successfully") {
          setSellers(response.data.data);
          setFilteredData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching seller data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSellers();
  }, []);

  // Pagination calculation
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  // ✅ Grand Total of all sellers
  const grandTotal = filteredData.reduce(
    (acc, seller) => acc + Number(seller.total_price || 0),
    0
  );

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4>All Sellers (By Product Stats)</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                value={search}
                className="form-control me-2"
                placeholder="Search Sellers"
                onChange={handleSearch}
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(sellers)}>All</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <button className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} /> Download
              </button>
            </div>
          </div>

          <div className="card" style={{ position: "relative" }}>
            <div className="card-body table-responsive" style={{ paddingBottom: "70px" }}>
              {loading ? (
                <div className="text-center my-5">
                  <Spinner animation="border" />
                </div>
              ) : (
                <>
                  <table className="custom-table table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Seller Name</th>
                        <th>Email</th>
                        <th>Total Products</th>
                        <th>Total Price</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.map((seller, index) => (
                        <tr key={seller.seller_id}>
                          <td>{indexOfFirstRecord + index + 1}</td>
                          <td>
                            {seller.first_name} {seller.last_name}
                          </td>
                          <td>{seller.seller_email}</td>
                          <td>{seller.total_products}</td>
                          <td>₹{Number(seller.total_price).toLocaleString()}</td>
                          <td>
                            <Link
                              target="_blank"
                              to={`/admin/sellerlistingspricelist/${seller.seller_id}`}
                              className="btn btn-info btn-sm"
                            >
                              <Eye size={15} /> View Listings
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Pagination */}
                  <nav>
                    <ul className="pagination justify-content-end">
                      {[...Array(totalPages)].map((_, i) => (
                        <li
                          className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                          key={i}
                          onClick={() => setCurrentPage(i + 1)}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="page-link">{i + 1}</span>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </>
              )}
            </div>

            {/* ✅ Sticky Grand Total */}
            <div
              className="bg-light border-top p-3"
              style={{
                position: "sticky",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 10,
              }}
            >
              <h5 className="m-0 text-end">
  Grand Total Price:{" "}
  <span className="fw-bold">
    ₹{grandTotal.toLocaleString("en-IN")}
  </span>
</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerListCost;
